import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { lightenColor } from '@/helpers/functions/theme';

export const MemberBenefits = () => {
  const { theme } = useWidgetConfig();

  const lighterBackground = lightenColor(theme?.bodyColor ?? '#FFF7ED', 90);

  return (
    <div
      className='rounded-lg border p-4'
      style={{ backgroundColor: lighterBackground, borderColor: lighterBackground }}
    >
      <h4 className='pb-2'>🎁 Member Benefits</h4>
      <ul className='my-0 space-y-1 pl-4 text-sm'>
        <li>Exclusive discounts and offers</li>
        <li>Birthday rewards and surprises</li>
        <li>Early access to new products</li>
        <li>Free shipping on select orders</li>
      </ul>
    </div>
  );
};
